// extracted by mini-css-extract-plugin
module.exports = {"text":"menu_text__FlwQh","menuLinkForNav":"menu_menuLinkForNav__LmBZe","menuLinkForNavOpen":"menu_menuLinkForNavOpen__2u4SV"};